import { useLocale } from "next-intl";
import { useQuery } from "@tanstack/react-query";

import { getBettingMarketsSuspensions } from "@/api/bettingMarkets";
import { BettingMarketsQueryKeys } from "./bettingMarketsQueryKeys";

export const useBettingMarketsSuspensions = (
  targetUsername?: string,
  sportCategory?: string
) => {
  const lang = useLocale();

  return useQuery({
    queryKey: [
      BettingMarketsQueryKeys.BettingMarketsSuspensions,
      targetUsername,
      sportCategory,
    ],
    queryFn: ({ signal }) =>
      getBettingMarketsSuspensions({
        signal,
        params: { lang, targetUsername, sportCategory },
      }),
  });
};
